export default function validateInstallationSiteName(value?: string) {
  let error;
  return error;
}
